import axios from "axios";
import { DateTime } from "luxon";
import React from "react";
import Modal from "react-modal";

import { getToken } from "./authentication";

export default function DeleteModal({
  deleteDialog,
  setDeleteDialog,
  surveyruns_mutate,
}) {
  return (
    <Modal
      isOpen={!!deleteDialog}
      aria={{
        labelledby: "heading",
        describedby: "full_description",
      }}
      onRequestClose={() => setDeleteDialog(null)}
      className="Teaser"
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.75)",
          zIndex: 10000,
        },
        content: {
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: " translate(-50%, -50%)",
        },
      }}
    >
      <div className="Teaser--inner">
        <div className="Teaser--header"></div>
        <h3 className="Teaser--title">
          <span className="Link layout-standalone size-small">
            Umfrage im Fach {deleteDialog?.subject} vom{" "}
            {DateTime.fromISO(deleteDialog?.date).toLocaleString(
              DateTime.DATE_MED
            )}
          </span>
        </h3>
      </div>
      <div className="Teaser--body">
        <div className="Teaser--text richtext">
          Möchtest du diese Umfrage löschen?{" "}
          {deleteDialog?.done ? (
            <>
              Damit löschst du auch alle Daten deiner abgeschlossenen Umfrage.
              Die Auswertung wird nicht mehr verfügbar sein.
            </>
          ) : (
            <>
              Damit löschst du auch{" "}
              {deleteDialog?.["individual_surveys"]?.length} individuelle
              Umfragen.
            </>
          )}{" "}
          Diese Aktion kann nicht rückgängig gemacht werden.
        </div>
        <div
          className="FormButtons"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <button
            className="Button size-large"
            onClick={() => setDeleteDialog(null)}
            autoFocus
          >
            Schliessen
          </button>
          <button
            className="Button color-primary size-large"
            onClick={async () => {
              await axios.delete(deleteDialog?.url, {
                headers: {
                  Authorization: `Token ${getToken()}`,
                },
              });
              await surveyruns_mutate();
              setDeleteDialog(null);
            }}
            style={{ backgroundColor: "red" }}
          >
            Umfrage löschen
          </button>
        </div>
      </div>
    </Modal>
  );
}
